var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.828 2.13l-8.75 15a1.25 1.25 0 11-2.16-1.26L9.572 2.75H1.75a1.25 1.25 0 010-2.5h10a1.25 1.25 0 011.078 1.88z",
    fill: "#00B9EF"
  })));
}

export default SvgSeven;